export interface Product {
    id: number;
    title: string;
    image: string;
    price: string;
    oldPrice?: string;
    rating: number;
    tag: string;
    category: string;
 }
 
 export const products: Product[] = [
    {
       id: 1,
       title: "اکانت استیم Elden Ring",
       image: "/gallery/1.jpg",
       price: "۲,۳۰۰,۰۰۰",
       oldPrice: "۲,۶۵۰,۰۰۰",
       rating: 5,
       tag: "AAA",
       category: "بازی‌های اکشن",
    },
    {
       id: 2,
       title: "اکانت استیم Cyberpunk 2077",
       image: "/gallery/2.jpg",
       price: "۱,۸۵۰,۰۰۰",
       oldPrice: "۲,۱۲۵,۰۰۰",
       rating: 4,
       tag: "AAA",
       category: "بازی‌های نقش‌آفرینی",
    },
    {
       id: 3,
       title: "اکانت استیم GTA V Premium",
       image: "/gallery/3.jpg",
       price: "۱,۵۰۰,۰۰۰",
       oldPrice: "۱,۷۳۰,۰۰۰",
       rating: 5,
       tag: "OPEN",
       category: "جهان‌باز",
    },
    {
       id: 4,
       title: "اکانت Rust",
       image: "/gallery/4.jpg",
       price: "۹۵۰,۰۰۰",
       oldPrice: "۱,۰۹۵,۰۰۰",
       rating: 4,
       tag: "SURVIVAL",
       category: "بازی‌های بقا",
    },
    {
       id: 5,
       title: "اکانت استیم Call of Duty: MW2",
       image: "/gallery/5.jpg",
       price: "۲,۸۰۰,۰۰۰",
       oldPrice: "۳,۲۲۰,۰۰۰",
       rating: 5,
       tag: "FPS",
       category: "تیراندازی اول شخص",
    },
    {
       id: 6,
       title: "اکانت Red Dead Redemption 2",
       image: "/gallery/6.jpg",
       price: "۲,۵۰۰,۰۰۰",
       oldPrice: "۲,۸۷۵,۰۰۰",
       rating: 5,
       tag: "ROCKSTAR",
       category: "اکشن و ماجراجویی",
    },
    {
       id: 7,
       title: "اکانت Dota 2 + آیتم‌های ویژه",
       image: "/gallery/7.jpg",
       price: "۵۵۰,۰۰۰",
       oldPrice: "۶۳۰,۰۰۰",
       rating: 4,
       tag: "MOBA",
       category: "چندنفره آنلاین",
    },
    {
       id: 8,
       title: "اکانت CS2 با Prime",
       image: "/gallery/8.jpg",
       price: "۹۰۰,۰۰۰",
       oldPrice: "۱,۰۳۵,۰۰۰",
       rating: 5,
       tag: "VALVE",
       category: "تیراندازی",
    },
    {
       id: 9,
       title: "اکانت FIFA 24 استیم",
       image: "/gallery/9.jpg",
       price: "۲,۱۰۰,۰۰۰",
       oldPrice: "۲,۴۱۵,۰۰۰",
       rating: 4,
       tag: "SPORTS",
       category: "ورزشی",
    },
    {
       id: 10,
       title: "اکانت PUBG استیم",
       image: "/gallery/9.jpg",
       price: "۶۵۰,۰۰۰",
       oldPrice: "۷۴۵,۰۰۰",
       rating: 4,
       tag: "BATTLE",
       category: "بتل رویال",
    },
    {
       id: 11,
       title: "اکانت استیم Hades",
       image: "/gallery/9.jpg",
       price: "۷۵۰,۰۰۰",
       oldPrice: "۸۶۵,۰۰۰",
       rating: 5,
       tag: "INDIE",
       category: "روگ‌لایک",
    },
    {
       id: 12,
       title: "اکانت استیم Resident Evil 4 Remake",
       image: "/gallery/9.jpg",
       price: "۲,۰۲۰,۰۰۰",
       oldPrice: "۲,۳۲۰,۰۰۰",
       rating: 5,
       tag: "HORROR",
       category: "ترسناک",
    },
    {
       id: 13,
       title: "اکانت Forza Horizon 5",
       image: "/gallery/9.jpg",
       price: "۲,۴۰۰,۰۰۰",
       oldPrice: "۲,۷۶۰,۰۰۰",
       rating: 4,
       tag: "RACING",
       category: "ماشین‌سواری",
    },
    {
       id: 14,
       title: "اکانت استیم The Witcher 3: Wild Hunt",
       image: "/gallery/9.jpg",
       price: "۱,۲۵۰,۰۰۰",
       oldPrice: "۱,۴۴۰,۰۰۰",
       rating: 5,
       tag: "RPG",
       category: "نقش‌آفرینی",
    },
    {
       id: 15,
       title: "اکانت استیم Portal 2",
       image: "/gallery/9.jpg",
       price: "۴۵۰,۰۰۰",
       oldPrice: "۵۲۰,۰۰۰",
       rating: 5,
       tag: "PUZZLE",
       category: "معمایی",
    },
    {
       id: 16,
       title: "اکانت استیم ARK: Survival Evolved",
       image: "/gallery/9.jpg",
       price: "۸۸۰,۰۰۰",
       oldPrice: "۱,۰۱۵,۰۰۰",
       rating: 4,
       tag: "SURVIVAL",
       category: "بازی‌های بقا",
    },
    {
       id: 17,
       title: "اکانت استیم Dead by Daylight",
       image: "/gallery/9.jpg",
       price: "۷۳۰,۰۰۰",
       oldPrice: "۸۴۰,۰۰۰",
       rating: 4,
       tag: "HORROR",
       category: "ترسناک چندنفره",
    },
    {
       id: 18,
       title: "اکانت استیم Left 4 Dead 2",
       image: "/gallery/9.jpg",
       price: "۳۲۰,۰۰۰",
       oldPrice: "۳۷۰,۰۰۰",
       rating: 4,
       tag: "COOP",
       category: "همکاری تیمی",
    },
    {
       id: 19,
       title: "اکانت استیم Sea of Thieves",
       image: "/gallery/9.jpg",
       price: "۱,۴۰۰,۰۰۰",
       oldPrice: "۱,۶۱۰,۰۰۰",
       rating: 4,
       tag: "ADVENTURE",
       category: "ماجراجویی چندنفره",
    },
    {
       id: 20,
       title: "اکانت استیم Hollow Knight",
       image: "/gallery/9.jpg",
       price: "۵۸۰,۰۰۰",
       oldPrice: "۶۶۵,۰۰۰",
       rating: 5,
       tag: "INDIE",
       category: "پلتفرمر",
    },
 ];
 